import React from 'react';
import Translation from '../General/Translation';
import MovieSearchLinkContainer from '../MovieSearchForm/MovieSearchLinkContainer';
import ElbenWaldContentMenu from './ElbenWaldContentMenu';
import { useState } from 'react';
import ElbenWaldLogo from './ElbenWaldLogo';


const UserContentMenu = ({
    hasLogin=false,
    hasConcessionShop=false,
    hasVoucherShop=false,
    isLoggedIn, 
    cartCount, 
    programOverviewUrl,
    features,
    translation, 
    affiliateSlug,
    openPopup
}) => {
    const [showMenu, setShowMenu] = useState(false)

    return (
        <>
            {hasLogin && <>
                <button onClick={() => openPopup('login')} className='pipe-button user-content-button login'>
                    {isLoggedIn ? (
                        <div className='my-account-button'>
                            <span className='user-content-button-text text-medium-navigation'>
                                <Translation id="account_name" trans={translation}>Mein Konto</Translation>
                            </span>
                        </div>
                    ) : (
                        <div className='login-button'>
                            <span className='user-content-button-text text-medium-navigation'>            
                                <Translation id="login_name" trans={translation}>Login</Translation>
                            </span>
                        </div>
                    )}
                </button>

                <button onClick={() => openPopup('cart')} className='pipe-button cart'>
                    <div className='cart-button'>
                        <span className='user-content-button-text text-medium-navigation'>
                            <Translation id="shopping_cart_name" trans={translation}>Warenkorb</Translation>
                        </span>
                        <span className='cart-counter'>{cartCount}</span>
                    </div>
                </button>
            </>}

            {hasConcessionShop && <button onClick={() => openPopup('concession')} className='pipe-button concession'>
                <div className='concession-button'>
                    <span className='user-content-button-text text-medium-navigation'>
                        <Translation id="snack_shop_name" trans={translation}>Snacks & Drinks</Translation>
                    </span>
                </div>
            </button>}

            {hasVoucherShop && <button onClick={() => openPopup('vouchers')} className='pipe-button vouchers'>
                <div className='voucher-button'>
                    <span className='user-content-button-text text-medium-navigation'>
                        <Translation id="shop_name" trans={translation}>Gutscheinshop</Translation>
                    </span>
                </div>
            </button>}
        
            {features.has_merchandising && affiliateSlug && (
                <>
                    <button onClick={() => setShowMenu(!showMenu)} className='pipe-button elbenwald'>
                        <ElbenWaldLogo/>
                    </button>
                    {showMenu && <ElbenWaldContentMenu
                        translation={translation}
                        affiliateSlug={affiliateSlug}
                        setShowMenu={setShowMenu}
                    />}
                </>
            )}

            <div className='pipe-button search'>
                <div className='search-button'>
                    <MovieSearchLinkContainer
                        searchLinkClass='user-content-button-text text-medium-navigation'
                        iconThin={true}
                        programOverviewUrl={programOverviewUrl}
                        translation={translation}

                    />
                </div>
            </div>
        </>
    )
}

export default UserContentMenu